module.exports = __webpack_public_path__ + "static/media/wiip-icons.287840d6.ttf";